import 'App.css';

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { SnackbarProvider } from 'notistack';

import ThemeProvider from '@mui/material/styles/ThemeProvider';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { ProvideCommunity } from 'PAM/hooks/useCommunity';
import theme from 'muiTheme.js';
import { configContext, useGetAppConfig } from 'hooks/useAppConfig';
import { HashRouter as Router } from 'react-router-dom';

import AppRoutes from 'AppRoutes';
import { ContainerWithCard, LineLoader } from '@timmons-group/shared-react-components';
import { ProvideAuth } from '@timmons-group/shared-react-components/hooks';

const App = () => {
  const [config, setConfig] = useState(null);

  // fetch a config with useEffect
  useEffect(() => {
    if (!config) {
      axios.get('/api/oauth/config').then(res => {
        setConfig(res.data);
      }).catch(err => {
        console.log('err', err);
        setConfig({ error: 'Config not found' });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!config) {
    return (
      <ContainerWithCard>
        <LineLoader message="Initializing..." color="secondary" />
      </ContainerWithCard >
    );
  }

  // Add context Auth provider to the App
  return (
    <ProvideAuth config={config}>
      <ThemeAndRoutes />
    </ProvideAuth>
  );
}

const ThemeAndRoutes = () => {
  // useGetAppConfig will immediately attempt to load the tenant specific application config on mount
  const appConfig = useGetAppConfig();

  // Dont show the app unless the config is loaded
  if (appConfig.isLoaded) {
    return (
      // appConfig is provided to all children use hook useConfig to consume
      <configContext.Provider value={appConfig?.config}>
        {/*
          theme is passed down to all children
          it can be accessed via the useTheme hook provided by the mui/material
        */}
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Router>
              <SnackbarProvider maxSnack={3} anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                <ProvideCommunity>
                  <AppRoutes />
                </ProvideCommunity>
              </SnackbarProvider>
            </Router>
          </LocalizationProvider>
        </ThemeProvider>
      </configContext.Provider>
    );
  }
  else {
    return (
      <ContainerWithCard>
        <LineLoader color="primary" message="Loading Application theme and configuration..." />
      </ContainerWithCard>
    );
  }
}

export default App;
